export interface TokenData {
  accessToken: string;
  refreshToken?: string;
  expiresAt: number;
}

let tokenData: TokenData | null = null;

export function setTokenData(data: TokenData) {
  tokenData = data;
}

export function getAuthToken(): string | null {
  return tokenData?.accessToken ?? null;
}

export function getRefreshToken(): string | null {
  return tokenData?.refreshToken ?? null;
}

export function getTokenExpiry(): number | null {
  return tokenData?.expiresAt ?? null;
}

export function isTokenExpired(): boolean {
  if (!tokenData?.expiresAt) return true;
  return Date.now() >= tokenData.expiresAt * 1000;
}

export function clearAuthTokenData() {
  tokenData = null;
}
